import React from 'react';

import IMG_CONTACT from 'assets/images/websites-portfolio/contact.png';
import IMG_HOME from 'assets/images/websites-portfolio/home.png';
import IMG_PRICES from 'assets/images/websites-portfolio/prices.png';
import IMG_TEAM from 'assets/images/websites-portfolio/team.png';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import C from 'utils/values/constant.util';

import CN from './PagesShowcase.module.scss';

const DATA_PAGES = C([
  { id: 1, title: 'Homepage', subtitle: 'Integrated with online booking', image: IMG_HOME },
  { id: 2, title: 'Team', subtitle: 'SEO optimisation', image: IMG_TEAM },
  { id: 3, title: 'Pricelist', subtitle: 'Integrated with Slick for real time updates', image: IMG_PRICES },
  { id: 4, title: 'Contact', subtitle: 'Integrated with Google Maps', image: IMG_CONTACT },
]);

const PagesShowcase = ({ tag }) => (
  <div className={CN.component} data-bem="PagesShowcase" data-tag={fromAnyToTrimmed(tag)}>
    {DATA_PAGES.map((page) => (
      <div className={CN.card} key={page.id}>
        <div className={CN.imageContainer}>
          <img src={page.image} alt={page.title} />
        </div>
        <div className={CN.textContainer}>
          <div className={CN.title}>{page.title}</div>
          <div className={CN.subTitle}>{page.subtitle}</div>
        </div>
      </div>
    ))}
  </div>
);

export default PagesShowcase;
